<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-banner
          color="blue-grey lighten-5"
          class="black--text"
          shaped
          single-line
        >
          Domicilio
        </v-banner>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-row dense>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Nacionalidad"
              rules="required"
            >
              <v-select
                :items="nationalities"
                label="Nacionalidad*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
                v-model.trim="nationality"
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-select>
            </validation-provider>
          </v-col>
          <v-col v-if="nationality == 'Otra'">
            <validation-provider
              v-slot="{ errors, valid }"
              name="Nacionalidad"
              rules="required|max:80"
            >
              <v-text-field
                :counter="80"
                maxlength="80"
                v-model.trim="generalInfoData.nationality"
                label="Nombre de nacionalidad*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Entidad federativa de nacimiento"
              rules="required"
            >
              <v-autocomplete
                :items="federalEntitiesBird"
                item-text="name"
                label="Entidad federativa de nacimiento*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
                v-model.trim="generalInfoData.birthFederalEntity"
                no-data-text="Sin resultados disponibles."
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-autocomplete>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Estado civil"
              rules="required"
            >
              <v-autocomplete
                :items="maritalStatus"
                item-text="text"
                item-value="value"
                label="Estado civil*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
                v-model.trim="generalInfoData.maritalStatus"
                no-data-text="Sin resultados disponibles."
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-autocomplete>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-row dense>
          <v-col cols="6">
            <validation-provider
              v-slot="{ errors, valid }"
              name="Calle"
              rules="required|max:100"
            >
              <v-text-field
                :counter="100"
                maxlength="100"
                v-model.trim="generalInfoData.street"
                label="Calle*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Número exterior"
              rules="required|max:10"
            >
              <v-text-field
                :counter="10"
                maxlength="10"
                v-model.trim="generalInfoData.outdoorNumber"
                label="Número interior*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Número interior"
              rules="max:10"
            >
              <v-text-field
                :counter="10"
                maxlength="10"
                v-model.trim="generalInfoData.interiorNumber"
                label="Número interior (opcional)"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon
                  slot="append"
                  :color="
                    valid && generalInfoData.interiorNumber ? 'warning' : ''
                  "
                >
                  {{
                    valid && generalInfoData.interiorNumber ? " mdi-check" : ""
                  }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-row dense>
          <v-col cols="3">
            <validation-provider
              v-slot="{ errors, valid }"
              name="Código postal"
              rules="required|max:5"
            >
              <v-text-field
                :counter="5"
                maxlength="5"
                v-model.trim="generalInfoData.postalCode"
                @input="listAllByPostalCode()"
                label="Código postal*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Entidad federativa"
              rules="required"
            >
              <v-autocomplete
                :items="federalEntities"
                v-if="$utilFront.nonEmptyList(federalEntities)"
                label="Entidad federativa*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
                v-model.trim="generalInfoData.federalEntity"
                no-data-text="Sin resultados disponibles."
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-autocomplete>
              <v-text-field
                v-if="$utilFront.isEmptyList(federalEntities)"
                :counter="100"
                maxlength="100"
                v-model.trim="generalInfoData.federalEntity"
                label="Entidad federativa*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Municipio"
              rules="required"
            >
              <v-autocomplete
                :items="municipalities"
                v-if="$utilFront.nonEmptyList(municipalities)"
                label="Municipio*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
                v-model.trim="generalInfoData.municipality"
                no-data-text="Sin resultados disponibles."
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-autocomplete>
              <v-text-field
                v-if="$utilFront.isEmptyList(municipalities)"
                :counter="100"
                maxlength="100"
                v-model.trim="generalInfoData.municipality"
                label="Municipio*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Colonia"
              rules="required"
            >
              <v-autocomplete
                :items="colonies"
                v-if="$utilFront.nonEmptyList(colonies)"
                label="Colonia*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
                v-model.trim="generalInfoData.colony"
                no-data-text="Sin resultados disponibles."
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-autocomplete>
              <v-text-field
                v-if="$utilFront.isEmptyList(colonies)"
                :counter="100"
                maxlength="100"
                v-model.trim="generalInfoData.colony"
                label="Colonia*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-banner
          color="blue-grey lighten-5"
          class="black--text"
          shaped
          single-line
        >
          Contacto
        </v-banner>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-row dense>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Teléfono móvil"
              rules="required|max:10|numeric|regex:^[0-9]+$"
            >
              <v-text-field
                required
                :counter="10"
                :maxlength="10"
                v-model.number="generalInfoData.phone"
                label="Teléfono móvil*"
                clearable
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon
                  slot="append"
                  :color="valid && generalInfoData.phone ? 'success' : ''"
                >
                  {{ valid && generalInfoData.phone ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Correo electrónico"
              rules="email|max:50"
            >
              <v-text-field
                type="email"
                :counter="50"
                maxlength="50"
                v-model.trim="generalInfoData.email"
                label="Correo electrónico (opcional)"
                clearable
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon
                  slot="append"
                  :color="valid && generalInfoData.email ? 'success' : ''"
                >
                  {{ valid && generalInfoData.email ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>

          <v-col>
            <validation-provider
              v-slot="{ errors, valid }"
              name="Teléfono casa"
              rules="max:10|numeric|regex:^[0-9]+$"
            >
              <v-text-field
                :counter="10"
                :maxlength="10"
                v-model.trim="generalInfoData.homePhone"
                label="Teléfono casa (opcional)"
                clearable
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon
                  slot="append"
                  :color="valid && generalInfoData.homePhone ? 'success' : ''"
                >
                  {{ valid && generalInfoData.homePhone ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  props: {},
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      nationality: null,
      nationalities: [
        { text: "Mexicana", value: "Mexicana" },
        { text: "Otra", value: "Otra" },
      ],
      federalEntitiesBird: [],
      maritalStatus: [],
      federalEntities: [],
      municipalities: [],
      colonies: [],
    };
  },
  created() {
    this.listAll();
  },
  methods: {
    listAll() {
      FederalEntityRequest.listAllFederalEntity().then((res) => {
        this.federalEntitiesBird = res.data.data;
      });
      EnumRequest.listAllMaritalStatus().then((res) => {
        this.maritalStatus = res.data.data;
      });
      if (this.$utilFront.nonEmpty(this.generalInfoData.nationality)) {
        let nationality = this.nationalities.filter((item) => {
          return item.value == this.generalInfoData.nationality;
        });
        if (nationality.length == 0) {
          this.nationalities.push({
            name: this.generalInfoData.nationality,
            text: this.generalInfoData.nationality,
          });
        }
        this.nationality = this.generalInfoData.nationality;
      }
    },
    listAllByPostalCode() {
      this.federalEntities = [];
      this.municipalities = [];
      this.colonies = [];
      this.generalInfoData.federalEntity = null;
      this.generalInfoData.municipality = null;
      this.generalInfoData.colony = null;

      if (this.generalInfoData?.postalCode?.length >= 5) {
        let param = this.generalInfoData.postalCode;
        console.log(param);
        SepomexRequest.listAllByPostalCode(param).then((res) => {
          this.federalEntities = res.data
            .map((item) => item.federalEntity)
            .filter(this.$utilFront.onlyUnique);
          this.municipalities = res.data
            .map((item) => item.municipality)
            .filter(this.$utilFront.onlyUnique);
          this.colonies = res.data
            .map((item) => item.settlement)
            .filter(this.$utilFront.onlyUnique);
          if (this.$utilFront.isEmptyList(this.colonies)) {
            this.$utilFront.notifications(
              "Código postal no encontrado, ingrese manualmente",
              "WARNING"
            );
          } else {
            this.generalInfoData.federalEntity = this.federalEntities[0];
            this.generalInfoData.municipality = this.municipalities[0];
            this.generalInfoData.colony = this.colonies[0];
            this.$utilFront.notifications(
              `${this.colonies.length} resultado(s) relacionado(s)`,
              "SUCCESS"
            );
          }
        });
      }
    },
    laststep() {
      this.$emit("laststep", 2);
    },
    nextstep() {
      this.$emit("nextstep", 4);
    },
  },
};
</script>
